import script from "./UiColumnsMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./UiColumnsMenu.vue?vue&type=script&setup=true&lang=js"

import "./UiColumnsMenu.vue?vue&type=style&index=0&id=2251763e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2251763e"]])

export default __exports__